import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { backButton } from '@telegram-apps/sdk-react';
import PropTypes from 'prop-types';

export default function Page({ children, redirect }) {
  const navigate = useNavigate();

  const redirectFunction = useCallback(() => {
    navigate(redirect);
  }, [navigate, redirect]);

  useEffect(() => {
    if (redirect) {
      backButton.show();
      backButton.onClick(redirectFunction);
    }
    return () => {
      backButton.hide();
      backButton.offClick(redirectFunction);
    };
  }, [redirect, redirectFunction]);

  return children;
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  redirect: PropTypes.string,
};

Page.defaultProps = {
  redirect: null,
};
